<template>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">Configuración de tareas automáticas</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <el-checkbox label="Activar tareas automáticas CRON"
                        v-model="form.tasks_cron_notification"
                    ></el-checkbox><br>
                    <small>Habilita el sistema para generar y enviar recordatorios de pagos de pago automáticamente.</small>
                </div>

                <div class="col-12">
                    <h3>Notificaciones</h3>
                </div>
                <div class="col-12">
                    <el-switch v-model="form.enable_tasks_cron_notification"></el-switch>
                    Habilitar notificaciones de fecha de gracia<br>
                    
                </div>

                <template v-if="form.enable_tasks_cron_notification">
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Días antes dela fecha de gracia
                            </label>
                            <el-input v-model="form.days_reminder_notification" placeholder="Ingrese la cantidad de días"
                                type="number"
                                min="0"
                                step="1"
                            >
                                <template slot="append">
                                    Días
                                </template>
                            </el-input>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Hora de ejecución de la notificación
                            </label>
                            <el-time-select v-model="form.hours_cron_notification" placeholder="Ingrese la hora"
                                :picker-options="{
                                    start: '00:00',
                                    end: '23:59',
                                    step: '00:01'
                                }"
                            ></el-time-select>
                        </div>
                    </div>
                    <div class="col-12">
                        <h3>Plantilla de mensaje</h3>
                        <small>Personaliza el mensaje que recibirán los clientes. Usa variables para datos dinámicos</small>
                    </div>
                    <div class="col-12">
                        <!-- <textarea
                            v-model="form.message_cron_notification"
                            class="form-control"
                            rows="6"
                            style="width: 100%; min-height: 140px; resize: vertical; box-sizing: border-box;"
                            placeholder="Escribe aquí el mensaje..."
                        ></textarea> -->
                        <vue-ckeditor
                            type="classic"
                            v-model="form.message_cron_notification"
                            :editors="editors"
                        ></vue-ckeditor>
                    </div>
                    <div class="col-12">
                        <div>Variables disponibles:</div>
                        <div class="d-flex align-items-center justify-content-center flex-wrap gap-1">
                            <el-tooltip content="Nombre del cliente a quien se notifica" placement="bottom" effect="light">
                                <el-button>@variable_nombre</el-button>
                            </el-tooltip>
                            <el-tooltip content="Nombre del plan del cliente" placement="bottom" effect="light">
                                <el-button>@variable_plan</el-button>
                            </el-tooltip>
                            <el-tooltip content="El precio del plan (bien si esta configurado uno nuevo o del plan por defecto)" placement="bottom" effect="light">
                                <el-button>@variable_precios</el-button>
                            </el-tooltip>
                            <el-tooltip content="Fecha de pago" placement="bottom" effect="light">
                                <el-button>@variable_fecha_pago</el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
                <div class="col-6 mt-3 mb-3">
                    <el-switch v-model="form.enable_tasks_cron_payment_order"></el-switch>
                    Habilitar creación de orden de pago<br>
                </div>
                <div class="col-6 mt-3 mb-3">
                    <el-switch :disabled="!form.enable_tasks_cron_payment_order" v-model="form.notify_tasks_cron_payment_order"></el-switch>
                    Habilitar notificaciones de orden de pago<el-tooltip class="item" effect="dark" placement="top-start" 
                    content="Una vez generada la orden de pago, se enviará automáticamente la notificación">
                                    <i class="fa fa-info-circle"></i>
                    </el-tooltip><br>
                </div>
                    
                    <template v-if="form.enable_tasks_cron_payment_order">
                    <div class="col-12 col-lg-12">
                        <div class="form-group d-flex align-items-center">
                            <label class="mr-2 mb-0">
                                Fecha de gracia: Cantidad de dias despues de la fecha de pago
                            </label>
                            <el-input v-model="form.days_of_grace_payment_order"  placeholder="Ingrese la cantidad de días"
                                type="number"
                                min="0"
                                step="1"
                                style="width: 180px;"
                            >
                                <template slot="append">
                                    Días
                                </template>
                            </el-input>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Mensual: fecha de pago
                                <el-tooltip class="item" effect="dark" placement="top-start" 
                                content="Se recomienda 7 dias antes">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input  placeholder="Ingrese la cantidad de días"
                                type="number"
                                min="0"
                                step="1"
                                v-model="form.days_payment_order_monthly"
                            >
                                <template slot="append">
                                    Días
                                </template>
                            </el-input>
                        </div>
                    </div>
                    
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Hora de ejecución de la orden de pago
                            </label>
                            <el-time-select  placeholder="Ingrese la hora"
                                :picker-options="{
                                    start: '00:00',
                                    end: '23:59',
                                    step: '00:01'
                                }"
                                v-model="form.hours_payment_order_monthly"
                            ></el-time-select>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Trimestral: fecha de pago
                                <el-tooltip class="item" effect="dark" placement="top-start" 
                                content="Se recomienda 15 dias antes">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input  placeholder="Ingrese la cantidad de días"
                                type="number"
                                min="0"
                                step="1"
                                v-model="form.days_payment_order_quarterly"
                            >
                                <template slot="append">
                                    Días
                                </template>
                            </el-input>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Hora de ejecución de la orden de pago
                            </label>
                            <el-time-select  placeholder="Ingrese la hora"
                                :picker-options="{
                                    start: '00:00',
                                    end: '23:59',
                                    step: '00:01'
                                }"
                                v-model="form.hours_payment_order_quarterly"
                            ></el-time-select>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Semestral: fecha de pago
                                <el-tooltip class="item" effect="dark" placement="top-start" 
                                content="Se recomienda 30 dias antes">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input  placeholder="Ingrese la cantidad de días"
                                type="number"
                                min="0"
                                step="1"
                                v-model="form.days_payment_order_biannual"
                            >
                                <template slot="append">
                                    Días
                                </template>
                            </el-input>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Hora de ejecución de la orden de pago
                            </label>
                            <el-time-select  placeholder="Ingrese la hora"
                                :picker-options="{
                                    start: '00:00',
                                    end: '23:59',
                                    step: '00:01'
                                }"
                                v-model="form.hours_payment_order_biannual"
                            ></el-time-select>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Anual: fecha de pago
                                <el-tooltip class="item" effect="dark" placement="top-start" 
                                content="Se recomienda 30 dias antes">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input  placeholder="Ingrese la cantidad de días"
                                type="number"
                                min="0"
                                step="1"
                                v-model="form.days_payment_order_annual"
                            >
                                <template slot="append">
                                    Días
                                </template>
                            </el-input>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">
                                Hora de ejecución de la orden de pago
                            </label>
                            <el-time-select  placeholder="Ingrese la hora"
                                :picker-options="{
                                    start: '00:00',
                                    end: '23:59',
                                    step: '00:01'
                                }"
                                v-model="form.hours_payment_order_annual"
                            ></el-time-select>
                        </div>
                    </div>
                    </template>
            </div>
            <div class="row mt-2">
                <div class="col-12 text-right">
                    <el-button type="primary"
                        @click="submit"
                        :loading="loading_submit"
                    >
                        Guardar
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
    import VueCkeditor from 'vue-ckeditor5'

    export default {
        components: {
            "vue-ckeditor": VueCkeditor.component
        },
        data() {
            return {
                loading_submit: false,
                resource: 'configurations',
                form: {
                    tasks_cron_notification: false,
                    days_reminder_notification: 0,
                    hours_cron_notification: moment().hour(10).minute(0).second(0).format('HH:mm'),
                    enable_tasks_cron_notification: false,
                    message_cron_notification: null,
                    enable_tasks_cron_payment_order: false,
                    notify_tasks_cron_payment_order: false,
                    days_of_grace_payment_order: 0,
                    days_payment_order_monthly: 7,
                    hours_payment_order_monthly: '09:00',
                    days_payment_order_quarterly: 15,
                    hours_payment_order_quarterly: '09:00',
                    days_payment_order_biannual: 30,
                    hours_payment_order_biannual: '09:00',
                    days_payment_order_annual: 30,
                    hours_payment_order_annual: '09:00',
                },
                editors: {
                    classic: ClassicEditor
                }
            }
        },

        async created() {
            await this.loadData()
        },

        methods: {
            async loadData() {
                try {
                    const { data } = await this.$http.get(`/${this.resource}/cron-notification`)
                    if (data.config) {
                        Object.assign(this.form, data.config)
                        if (!this.form.enable_tasks_cron_payment_order) {
                            this.form.notify_tasks_cron_payment_order = false
                        }
                    }
                } catch (error) {
                    const message = error.reponse.data.message || 'Ocurrió un error inesperado'
                    this.$message.error(message)
                }
            },

            async submit() {
                try {
                    this.loading_submit = true
                    const { data } = await this.$http.post(`/${this.resource}/cron-notification`, this.form)
                    if (data.success) {
                        this.$message.success(data.message)
                        await this.loadData()
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    const message = error.reponse.data.message || 'Ocurrió un error inesperado'
                    this.$message.error(message)
                } finally {
                    this.loading_submit = false
                }
            }
        },
        watch: {
            'form.enable_tasks_cron_payment_order'(value) {
                if (!value) {
                    this.form.notify_tasks_cron_payment_order = false
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/configuration/task_configuration.vue